<template>
    <div id="app">
        <div class="header">
            <div class="containers clearfix">
                <el-row class="PC">
                    <el-col :span="4">
                        <div class="index-logo">
                            <router-link to="/">
                                <img style="width: auto;height:50px" src="../static/image/logo.png"/>
                            </router-link>
                        </div>
                    </el-col>
                    <el-col :span="14">
                        <el-menu
                            :default-active="activeIndex"
                            :active-text-color="activeColor"
                            :router="true"
                            class="el-menu-demo"
                            background-color="#2B2A2A"
                            active-text-color="#00A6FF"
                            text-color="#FFFFFF"
                            mode="horizontal"
                            @select="handleSelect">
                            <el-menu-item index="/">首页</el-menu-item>
                            <!--              <el-menu-item index="/exhibitionService">展会服务</el-menu-item>-->
                            <el-menu-item index="/exhibitionCenter">展会中心</el-menu-item>
                            <!-- <el-menu-item index="/internationalExhibition">国际展会</el-menu-item> -->
                            <el-menu-item index="/news">展会资讯</el-menu-item>
<!--                            <el-menu-item index="">会展中心</el-menu-item>-->
                            <el-menu-item index="/contactUs">展会展品</el-menu-item>
                            <el-menu-item index="/conventionCenter">会展中心</el-menu-item>
<!--                            <el-menu-item index="">展会合作</el-menu-item>-->
                        </el-menu>
                    </el-col>
                    <el-col :span="6">
                        <div style="line-height: 80px;" class="text-right">
                            <img @click="toPersonInformation" style="width: 30px;height:30px;border-radius: 50%"
                                 :src="avatar"/>
                            <el-button v-if="!isLogin" type="text" style="padding:0" @click="goLogin('/login')"
                                       class="btn-box">登录
                            </el-button>
                            <el-button v-if="!isLogin" type="text" style="padding:0" @click="goLogin('/register')"
                                       class="btn-box">注册
                            </el-button>
                            <el-button v-if="isLogin" type="text" style="padding:0" class="btn-box" @click="logout()">
                                注销
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
<!--                <el-row type="flex" class="row-bg Mobile" justify="space-between">-->
<!--                    <el-col :span="4" class="m-box m-index-logo" style="padding: 0">-->
<!--                        <router-link to="/">-->
<!--                            <img style="width: auto;height:35px" src="../static/image/logo.png">-->
<!--                        </router-link>-->
<!--                    </el-col>-->

<!--                    <el-col :span="8" :offset="12" class="m-box text-right">-->
<!--                        <div style="display: flex">-->
<!--                            <div @click="mobileLogin">-->
<!--                                <img style="width: 30px;height:30px;margin-right: 20px;border-radius: 50%"-->
<!--                                     :src="avatar"/>-->
<!--                            </div>-->
<!--                            <div class="menu-btn" @click="mobileNav"><span></span><span></span><span></span></div>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                </el-row>-->
                <div style="display: flex;justify-content: space-between;align-items: center" class="hidden-sm-and-up row-bg Mobile">
                    <div class="m-box m-index-logo" style="padding: 0">
                        <router-link to="/">
                            <img style="width: auto;height:35px" src="../static/image/logo.png">
                        </router-link>
                    </div>

                    <div class="m-box text-right">
                        <div style="display: flex;align-items: center">
                            <div @click="mobileLogin">
                                <img style="width: 30px;height:30px;margin-right: 20px;border-radius: 50%"
                                     :src="avatar"/>
                            </div>
                            <div class="menu-btn" @click="mobileNav"><span></span><span></span><span></span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="['mobile-nav',[mobile_login?'m-nav-show':'m-nav-hide']]">
            <el-row>
                <el-col :span="12" style="padding-left: 20px">
                    <img src="../static/image/logo.png" style="width: 90px;">
                </el-col>
                <el-col :span="12" class="text-right" style="padding-right: 20px">
                    <i class="el-icon-close" @click="mobileLogin" style="color: #FFFFFF;font-size: 30px"></i>
                </el-col>
            </el-row>
            <el-menu
                :default-active="activeIndex"
                :active-text-color="activeColor"
                :router="true"
                class="el-menu-vertical-demo"
                background-color="transparent"
                text-color="#fff"
                style="margin: 20px 0"
            >
                <el-menu-item v-if="!isLogin" index="/register" class="m-menu-icon icon1" @click="mobileLogin">
                    <span slot="title">注册</span>
                </el-menu-item>
                <el-menu-item v-if="!isLogin" index="/login" class="m-menu-icon icon2" @click="mobileLogin">
                    <span slot="title">登录</span>
                </el-menu-item>
                
                <el-menu-item v-if="isLogin" index="/myInformation" class="m-menu-icon icon3"
                              @click="toPersonInformation">
                    <span slot="title">个人中心</span>
                </el-menu-item>
                <!-- <el-menu-item v-if="isLogin" index="/myExhibitions" class="m-menu-icon icon3"
                              @click="toDetail('/myExhibitions')">
                    <span slot="title">我的展会</span>
                </el-menu-item>
                <el-menu-item v-if="isLogin" index="/reportExhibition" class="m-menu-icon icon3"
                              @click="toDetail('/reportExhibition')">
                    <span slot="title">发布展会</span>
                </el-menu-item>
                <el-menu-item v-if="isLogin" index="/myFocus" class="m-menu-icon icon3" @click="toDetail('/myFocus')">
                    <span slot="title">我的关注</span>
                </el-menu-item>
                <el-menu-item v-if="isLogin" index="/myGroup" class="m-menu-icon icon3" @click="toDetail('/myGroup')">
                    <span slot="title">我的组团</span>
                </el-menu-item> -->
                <!-- <el-menu-item v-if="isLogin" index="/myExhibits" class="m-menu-icon icon3"
                              @click="toDetail('/myExhibits')">
                    <span slot="title">我的展品</span>
                </el-menu-item> -->
<!--                <el-menu-item v-if="isLogin" index="/myNews" class="m-menu-icon icon3" @click="toDetail('/myNews')">-->
<!--                    <span slot="title">我的资讯</span>-->
<!--                </el-menu-item>-->
                <!-- <el-menu-item v-if="isLogin" index="/product" class="m-menu-icon icon3" @click="logout">
                    <span slot="title">注销</span>
                </el-menu-item> -->
            </el-menu>
        </div>

        <div :class="['mobile-nav',[mobile_nav?'m-nav-show':'m-nav-hide']]">
            <el-row>
                <el-col :span="12" style="padding-left: 20px">
                    <img src="../static/image/logo.png" style="width: 90px;">
                </el-col>
                <el-col :span="12" class="text-right" style="padding-right: 20px">
                    <i class="el-icon-close" @click="mobileNav" style="color: #FFFFFF;font-size: 30px"></i>
                </el-col>
            </el-row>
            <el-menu
                :default-active="activeIndex"
                :active-text-color="activeColor"
                :router="true"
                class="el-menu-vertical-demo"
                background-color="transparent"
                text-color="#fff"
                style="margin: 20px 0"
            >
                <el-menu-item index="/" class="m-menu-icon icon1" @click="mobileNav">
                    <span slot="title">首页</span>
                </el-menu-item>
                <!--        <el-menu-item index="/exhibitionService" class="m-menu-icon icon2" @click="mobileNav">-->
                <!--          <span slot="title">展会服务</span>-->
                <!--        </el-menu-item>-->
                <el-menu-item index="/exhibitionCenter" class="m-menu-icon icon3" @click="mobileNav">
                    <span slot="title">展会中心</span>
                </el-menu-item>
                <!-- <el-menu-item index="/internationalExhibition" class="m-menu-icon icon3" @click="mobileNav">
                    <span slot="title">国际展会</span>
                </el-menu-item> -->
                <el-menu-item index="/news" class="m-menu-icon icon4" @click="mobileNav">
                    <span slot="title">展会资讯</span>
                </el-menu-item>
<!--                <el-menu-item index="" class="m-menu-icon icon4" @click="mobileNav">-->
<!--                    <span slot="title">会展中心</span>-->
<!--                </el-menu-item>-->
                <el-menu-item index="/contactUs" class="m-menu-icon icon4" @click="mobileNav">
                    <span slot="title">展会展品</span>
                </el-menu-item>
                <el-menu-item index="/conventionCenter" class="m-menu-icon icon4" @click="mobileNav">
                    <span slot="title">会展中心</span>
                </el-menu-item>
<!--                <el-menu-item index="" class="m-menu-icon icon4" @click="mobileNav">-->
<!--                    <span slot="title">展会合作</span>-->
<!--                </el-menu-item>-->
            </el-menu>
        </div>
       
        <div :class="['main-content',{'pdb0':activeIndex == '/contactUs'}]">
            <router-view :class="[activeIndex == '/contactUs'?'':'content111']"></router-view>
        </div> 
        <Footer class="hidden-md-and-up"  v-if="activeIndex != '/login' && activeIndex != '/register' "></Footer>
        <Footer class="hidden-sm-and-down" ></Footer>
     
    </div>
</template>

<script>
import Footer from "./components/footer/Footer";
import ElCol from "element-ui/packages/col/src/col";

export default {
    name: "App",
    data() {
        return {
            activeIndex: "",
            activeColor: "#409EFF",
            mobile_nav: false,
            mobile_login: false,
            userInfo: {},
            isLogin: false,
            avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        };
    },
    components: {
        ElCol,
        Footer
    },
    methods: {
        toDetail(path) {
            this.$router.push({path: path})
        },
        toPersonInformation() {
            if (localStorage.getItem('token')) {
                this.$router.push({path: '/myInformation'})
            } else {
                this.$message('请先登录!')
                this.$router.push({path: '/login'})
            }
        },
        logout() {
            this.$confirm('此操作将退出登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.isLogin = false
                localStorage.clear();
                this.avatar = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
                this.$router.push({path: '/home'})
                this.$message({
                    type: 'success',
                    message: '退出成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleSelect(val) {
        },
        mobileLogin() {
            this.mobile_login = !this.mobile_login;
        },
        mobileNav() {
            this.mobile_nav = !this.mobile_nav;
        },
        getPath() {
            // this.activeIndex = this.$route.path;
            let currentPath = this.$route.path;
            if (currentPath.startsWith("/exhibitiondetail") || currentPath.startsWith("/exhibitsample")|| currentPath.startsWith("/internationalExhibition")) {
                this.activeIndex = "/contactUs";
            } else {
                this.activeIndex = currentPath;
            }
        },
        goLogin(url) {
            this.$router.push(url);
        },
        getLoginState() {
            if (localStorage.getItem('userInfo')) {
                this.isLogin = true
                this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
                this.avatar = this.userInfo.avatar ? this.userInfo.avatar : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
            }
        }
    },
    created() {
        this.activeIndex = this.$route.path;
        this.getPath();
    },
    watch: {
        $route: "getPath",
        $route(to, from) {
            this.getLoginState()
            this.getPath();
        }
    }
};
</script>

<style lang="less">

@import "style/common.less";

</style>



// WEBPACK FOOTER //
// src/App.vue